class GloweCartCrossSell extends HTMLElement {
  async connectedCallback() {
    if (this.dataset.loaded === 'true') return;
    const { productId, url } = this.dataset;
    if (!productId || !url) return;
    this.dataset.loaded = 'true';

    try {
      const response = await fetch(
        `${url}.json?product_id=${encodeURIComponent(productId)}&limit=3&intent=complementary`
      );
      if (!response.ok) throw new Error(`Recommendations returned ${response.status}`);
      const data = await response.json();
      const products = Array.isArray(data.products) ? data.products : [];
      const list = this.querySelector('[data-cross-sell-list]');
      if (!products.length || !list) return;

      for (const product of products) {
        const link = document.createElement('a');
        link.className = 'glowe-cart-cross-sell__item';
        link.href = product.url;

        const imageUrl = product.featured_image?.url || product.featured_image;
        if (imageUrl) {
          const image = document.createElement('img');
          image.className = 'glowe-cart-cross-sell__image';
          image.loading = 'lazy';
          image.alt = product.featured_image?.alt || product.title;
          image.src = imageUrl;
          link.append(image);
        }

        const copy = document.createElement('div');
        const title = document.createElement('p');
        title.className = 'glowe-cart-cross-sell__title';
        title.textContent = product.title;
        const price = document.createElement('p');
        price.className = 'glowe-cart-cross-sell__price';
        const currency = window.Shopify?.currency?.active;
        if (currency) {
          price.textContent = new Intl.NumberFormat(document.documentElement.lang, {
            style: 'currency',
            currency,
          }).format(product.price / 100);
        }
        copy.append(title, price);
        link.append(copy);
        list.append(link);
      }

      this.hidden = false;
    } catch (error) {
      this.hidden = true;
    }
  }
}

if (!customElements.get('glowe-cart-cross-sell')) {
  customElements.define('glowe-cart-cross-sell', GloweCartCrossSell);
}
